module.exports = __webpack_public_path__ + "images/ecb672c1626c5319250fc17898d9859e-Sports Empire.Authentic CA Dual logo.jpg";